import React, { SFC } from 'react';
import { connect } from 'react-redux';
import { CategoryData } from '../../redux/category/types';
import { getCategoriesUrl } from '../../urlService';
import StateInterface from '../../redux/types';
import { MAX_CATEGORY_DEPTH_LEVEL } from '../../../oneHeader/local/Overlays/BurgerFlyout/BurgerMenuContainer';
import { StyledSEOLink, StyledSeoLinksContainer } from './SeoLink';

const buildSEOLinks = (categoriesToBuild: CategoryData[]) =>
    (categoriesToBuild || []).map(category => (
        <ul key={category.name}>
            <li>
                <StyledSEOLink href={getCategoriesUrl(category.url)}>{category.name}</StyledSEOLink>
                {category.children &&
                    category.depthLevel < MAX_CATEGORY_DEPTH_LEVEL &&
                    buildSEOLinks(category.children)}
            </li>
        </ul>
    ));

export const CategorySeoLinks: SFC<{ categories: CategoryData[] }> = ({ categories }) => (
    <StyledSeoLinksContainer>{buildSEOLinks(categories)}</StyledSeoLinksContainer>
);

const mapStateToProps = (state: StateInterface): { categories: CategoryData[] } => {
    const categories = state.categories.originalCategories;
    return { categories };
};

export default connect(mapStateToProps)(CategorySeoLinks);
